module.exports = __webpack_public_path__ + "PTMETTAhome-2.b5123ab9.png";